import clsx from 'clsx';
import React, { forwardRef } from 'react';

type BaseInputProps = React.HTMLProps<HTMLInputElement> & {
  round?: string;
  icon?: React.ReactNode;
  leftIcon?: React.ReactNode;
};

export const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  ({ className, icon, leftIcon, round, type, ...props }, ref) => (
    <div className="relative">
      {leftIcon && (
        <div className="absolute inset-y-0 start-0 flex items-center ps-3">
          {leftIcon}
        </div>
      )}
      <input
        ref={ref}
        type={type}
        className={clsx(
          'block w-full appearance-none border border-gray-300 py-2 shadow-sm placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm',
          round,
          icon ? 'pr-12' : 'pr-4',
          leftIcon ? 'pl-10' : 'pl-4',
          className
        )}
        {...props}
      />
      {icon && (
        <div className="absolute inset-y-0 end-0 flex items-center pe-2">
          {icon}
        </div>
      )}
    </div>
  )
);

BaseInput.displayName = 'BaseInput';
